import { CardDetailsData } from '@/common/types/cards/details.type'
import React, { useEffect } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { cardDetailsComponents } from '../constants/cardDetails.constant'
import { ConsumptionValidationSchema } from '../schemas/create.schema'
import Alert from '@/common/components/Alert'
import { CircleXIcon } from 'lucide-react'
import { cardStatusAvailableToConsumption } from '../constants/cardStatusAvailableToConsumption.constant'
import { cardStatusTranslation } from '../constants/cardStatusTranslation.constant'

interface EquipmentInfoProps {
  companyFantasyName?: string
  companyBranchDisplayName?: string
  cardDetails?: CardDetailsData
  setValue?: UseFormSetValue<ConsumptionValidationSchema>
}

const EquipmentInfo = ({ companyFantasyName, companyBranchDisplayName, cardDetails, setValue }: EquipmentInfoProps) => {
  useEffect(() => {
    if (cardDetails && cardDetails?.id) {
      setValue?.('card_id', cardDetails?.id)
      setValue?.('card_type', cardDetails?.type)
    }
  }, [cardDetails?.id])

  if (!cardDetails?.id) {
    return (
      <Alert Icon={CircleXIcon} variant="error">
        <p className="text-danger-soft text-sm" data-testid="alert_card_not_found">
          Cartão não encontrado
        </p>
      </Alert>)
  }

  return (
    <>
      {React.createElement(cardDetailsComponents[cardDetails?.type as keyof typeof cardDetailsComponents], {
        cardDetails,
        companyFantasyName,
        companyBranchDisplayName,
      })}

      {cardDetails.status && !(cardStatusAvailableToConsumption).includes(cardDetails.status) && (
        <div className="flex items-center gap-3 bg-danger-soft/15 p-4 rounded-lg" data-testid="alert_card_status_not_available">
          <CircleXIcon strokeWidth={1.5} className="text-danger-soft size-5" />

          <div className="flex flex-col gap-y-px">
            <p className="text-danger-soft text-sm">
              Cartão com status indisponível para uso
            </p>

            {cardStatusTranslation[cardDetails.status] && (
              <p className="text-danger-soft text-xs">
                Status: {cardStatusTranslation[cardDetails.status]}
              </p>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default EquipmentInfo
